export default "__VITE_ASSET__CjywA0Lu__ 640w, __VITE_ASSET__DXsm3fFC__ 1024w, __VITE_ASSET__BoZ4xSTA__ 1920w";